/**
 * Currency Switcher Component
 * Custom element that handles currency switching following Shopify best practices
 */
if (!customElements.get('currency-switcher')) {
  class CurrencySwitcher extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.handleChangeBound = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.initialize();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    initialize() {
      // Find the select element within this component
      this.select = this.querySelector('select[data-currency-switcher="true"]');
      
      if (!this.select) {
        console.warn('[currency-switcher] No select element found with data-currency-switcher attribute');
        return;
      }

      this.setupCurrencySwitching();
    }

    setupCurrencySwitching() {
      if (!this.select) return;

      // Add change event listener
      this.select.addEventListener('change', this.handleChangeBound);
    }

    handleChange(event) {
      const selectedOption = event.target.options[event.target.selectedIndex];
      const currencyCode = selectedOption.value;

      if (!currencyCode) {
        console.warn('[currency-switcher] No currency code found');
        return;
      }

      // Construct URL with currency parameter following Shopify best practices
      // This preserves the current page URL while switching currency
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('currency', currencyCode);
      const targetUrl = currentUrl.toString();

      // Redirect to the new currency
      // This follows Shopify's standard currency switching approach
      window.location.href = targetUrl;
    }

    cleanup() {
      if (this.select) {
        this.select.removeEventListener('change', this.handleChangeBound);
      }
    }

    // Public method to get current currency
    getCurrentCurrency() {
      return this.select ? this.select.value : null;
    }

    // Public method to programmatically switch currency
    setCurrency(currencyCode) {
      if (!this.select) return false;
      
      const option = this.select.querySelector(`option[value="${currencyCode}"]`);
      if (option) {
        this.select.value = currencyCode;
        this.select.dispatchEvent(new Event('change'));
        return true;
      }
      
      return false;
    }
  }

  customElements.define('currency-switcher', CurrencySwitcher);
}
